import React from 'react';
import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { CookieWidget } from './CookieWidget';

export const CookiePolicy = () => {
  const handleBack = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Button
            variant="ghost"
            onClick={handleBack}
            className="text-cyan-600 hover:text-cyan-700 hover:bg-cyan-50"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Torna al sito
          </Button>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Title Section */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-cyan-100 rounded-full mb-4">
              <Shield className="w-8 h-8 text-cyan-600" />
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Cookie Policy
            </h1>
            <p className="text-lg text-gray-600">
              Io cambio insieme - Lista Civica
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </div>

          {/* Main Content */}
          <div className="space-y-6">
            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  1. Cosa sono i cookie
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web. 
                  Vengono utilizzati per far funzionare il sito in modo efficiente e per fornire informazioni ai proprietari del sito.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  2. Come utilizziamo i cookie
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Il nostro sito web utilizza solo cookie tecnici strettamente necessari per il funzionamento del sito. 
                  Non utilizziamo cookie di profilazione o di terze parti per scopi pubblicitari.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                  Cookie tecnici
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Questi cookie sono essenziali per il corretto funzionamento del sito web e non possono essere disabilitati. 
                  Includono cookie che consentono di:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Navigare tra le pagine del sito</li>
                  <li>Utilizzare le funzionalità essenziali del sito</li>
                  <li>Mantenere le preferenze di navigazione</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  3. Cookie utilizzati sul nostro sito
                </h2>
                
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="border-b-2 border-gray-200">
                        <th className="text-left py-3 px-4 font-semibold text-gray-900">Nome</th>
                        <th className="text-left py-3 px-4 font-semibold text-gray-900">Tipo</th>
                        <th className="text-left py-3 px-4 font-semibold text-gray-900">Durata</th>
                        <th className="text-left py-3 px-4 font-semibold text-gray-900">Scopo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-gray-200">
                        <td className="py-3 px-4 text-gray-700">session_id</td>
                        <td className="py-3 px-4 text-gray-700">Tecnico</td>
                        <td className="py-3 px-4 text-gray-700">Sessione</td>
                        <td className="py-3 px-4 text-gray-700">Gestione della sessione utente</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  4. Gestione dei cookie
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Puoi gestire o disabilitare i cookie attraverso le impostazioni del tuo browser. 
                  Tieni presente che la disabilitazione dei cookie tecnici potrebbe influire sul funzionamento del sito.
                </p>
                
                <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
                  Come gestire i cookie nei browser più comuni:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li>
                    <strong>Chrome:</strong> Impostazioni → Privacy e sicurezza → Cookie e altri dati dei siti
                  </li>
                  <li>
                    <strong>Firefox:</strong> Opzioni → Privacy e sicurezza → Cookie e dati dei siti web
                  </li>
                  <li>
                    <strong>Safari:</strong> Preferenze → Privacy → Gestisci i dati dei siti web
                  </li>
                  <li>
                    <strong>Edge:</strong> Impostazioni → Cookie e autorizzazioni sito → Gestisci ed elimina cookie e dati dei siti
                  </li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  5. Modifiche alla Cookie Policy
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Ci riserviamo il diritto di modificare questa Cookie Policy in qualsiasi momento. 
                  Le modifiche saranno pubblicate su questa pagina con la data di ultimo aggiornamento.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  6. Contatti
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Per qualsiasi domanda relativa a questa Cookie Policy, puoi contattarci attraverso 
                  il modulo presente nella sezione "Contatti" del nostro sito web.
                </p>
                <div className="mt-6">
                  <Button
                    onClick={handleBack}
                    className="bg-cyan-500 hover:bg-cyan-600 text-white"
                  >
                    Torna al sito
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      
      {/* Cookie Widget */}
      <CookieWidget />
    </div>
  );
};